// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3W472","content":"styles_content__TlcsK"};